export default "__VITE_ASSET__hoDS066e__"